import { styled, Typography } from '@mui/material';

export const BlackTypo = styled(Typography)(() => ({
  color: 'black',
}));
